// extracted by mini-css-extract-plugin
export default {"root":"dhpg__root"};